import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux';
import { SearchPageApp } from './components/search-page-app';
import { rootReducer } from './reducers/index';
import thunk from 'redux-thunk';
import { BrowserRouter, Route } from 'react-router-dom';
import { RouterToUrlQuery, addUrlProps, UrlQueryParamTypes, subquery, configureUrlQuery, urlQueryMiddleware } from 'react-url-query';
import { history } from './state-helpers/history';
import { GoogleAnalytics } from '../global/functions/analytics';
import { compose } from 'redux';

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(
        thunk,
        urlQueryMiddleware()
    )
));
configureUrlQuery({ history, addChangeHandlers: false });

//Render the search application by attaching it to the placeholder element search-page-app
const searchPageMount = document.getElementById('search-page-app');
const RouterContext = React.createContext({});

if (searchPageMount) {

    const root = createRoot(searchPageMount);
    //If there are tags, this is a landing page (I guess?)
    const tags = (window as any).bootstrap.tags;
    const isLandingPage = tags && tags.length;
    const searchDefaultSort = (window as any).bootstrap.searchDefaultSort;
    const searchMembershipSort = (window as any).bootstrap.searchMembershipSort;
    const searchPolicySort = (window as any).bootstrap.searchPolicySort;
    const searchPublicationsSort = (window as any).bootstrap.searchPublicationsSort;
    const searchPointofCareSort = (window as any).bootstrap.searchPointofCareSort;
    const searchShopSort = (window as any).bootstrap.searchShopSort;
    const searchHealthyChildrenSort = (window as any).bootstrap.searchHealthyChildrenSort;
    const searchNewsSort = (window as any).bootstrap.searchNewsSort;
    const searchRedBookSort = (window as any).bootstrap.searchRedBookSort;
    const analytics = new GoogleAnalytics();
    

    root.render(
        <Provider store={store}>
            <BrowserRouter>
                <Route>
                    {routeProps => (
                    <RouterContext.Provider value={routeProps}>
                        <RouterToUrlQuery routerContext={RouterContext}>
                            <SearchPageApp
                                isLandingPage={isLandingPage}
                                analytics={analytics}
                                searchDefaultSort={searchDefaultSort}
                                searchMembershipSort={searchMembershipSort}
                                searchPolicySort={searchPolicySort}
                                searchPublicationsSort={searchPublicationsSort}
                                searchPointofCareSort={searchPointofCareSort}
                                searchShopSort={searchShopSort}
                                searchHealthyChildrenSort={searchHealthyChildrenSort}
                                searchNewsSort={searchNewsSort}
                                searchRedBookSort={searchRedBookSort}/>
                        </RouterToUrlQuery>
                    </RouterContext.Provider>
                    )}
                </Route>
                </BrowserRouter>
        </Provider>);
}